import { hasPermission } from '@/hooks/useBackendMenu'
import { StatusAprovacao } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import StatusOcorrencia from '../atoms/StatusOcorrencia'
import FormDetalhesAfastamento from '../forms/DetalhesAfastamento'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import useService from '../service'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export function DetalhesAfastamento() {
    const { id } = useParams()
    const { data } = useDigitacaoContext()
    const {
        handleAprovar,
        handleExcluir,
        handleReprovar,
        handleAtualizarAfastamento,
    } = useService()
    const afastamento = data?.find(
        ({ afastamento }) => afastamento?.id === Number(id),
    )?.afastamento

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()
    const [excluindo, setExcluindo] = useState(false)

    if (!afastamento) return null

    const podeExcluir =
        hasPermission(['delete', 'Afastamentos']) || funcionarioPodeAjustar

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'Afastamentos'])}
            defaultValues={{
                ...afastamento,
                dias:
                    dayjs(afastamento?.dataFinal).diff(
                        afastamento?.dataInicial,
                        'day',
                    ) + 1,
            }}
            onSubmit={
                hasPermission(['update', 'Afastamentos'])
                    ? handleAtualizarAfastamento
                    : undefined
            }
        >
            <Dialog.Title>Detalhes do afastamento</Dialog.Title>
            <Dialog.Content>
                <FormDetalhesAfastamento />
                <Dialog.Content.Footer>
                    <StatusOcorrencia
                        tipoOcorrencia="AFASTAMENTO"
                        onApprove={
                            hasPermission(['update', 'Afastamentos'])
                                ? () =>
                                      handleAprovar('AFASTAMENTO', afastamento)
                                : undefined
                        }
                        onReject={
                            hasPermission(['update', 'Afastamentos'])
                                ? ({ motivo }) =>
                                      handleReprovar('AFASTAMENTO', {
                                          id: afastamento.id,
                                          motivo,
                                      })
                                : undefined
                        }
                    />
                </Dialog.Content.Footer>
                <ConfirmarExclusao
                    width="2xl"
                    open={excluindo}
                    onClose={() => setExcluindo(false)}
                    exigirMotivo={
                        afastamento.statusAprovacao != StatusAprovacao.PENDENTE
                    }
                    onConfirm={({ motivo }) =>
                        handleExcluir('AFASTAMENTO', { ...afastamento, motivo })
                    }
                    title="Tem certeza que deseja excluir o afastamento?"
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {podeExcluir && (
                    <Dialog.Actions.PrimaryButton
                        color="error"
                        data-testid="dialog-delete-button"
                        onClick={() => setExcluindo(true)}
                    >
                        Excluir
                    </Dialog.Actions.PrimaryButton>
                )}
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
